import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import s from "./ShopNotFound.module.css";
import { Button } from "../../../themeV2";

const isServerError = (error) => error?.status >= 500;

export default function ShopNotFound({ error }) {
  const serverError = isServerError(error);

  return (
    <div className={s.root}>
      <h2 className={s.title}>
        {serverError ? "Something went wrong" : "Shop not found"}
      </h2>
      <p className={s.text}>
        {serverError
          ? "We\u2019re having trouble loading this page. Please try again shortly."
          : "The shop you\u2019re looking for doesn\u2019t exist or may have been removed."}
      </p>
      <div className={s.actions}>
        {serverError ? (
          <Button size="sm" onClick={() => window.location.reload()}>
            Try Again
          </Button>
        ) : (
          <Button as={Link} to="/" size="sm">
            Go to Home
          </Button>
        )}
        <Link to="/shops" className={s.secondaryLink}>
          Browse Shops
        </Link>
      </div>
    </div>
  );
}

ShopNotFound.propTypes = {
  error: PropTypes.shape({
    status: PropTypes.number,
  }),
};
